// import Storage from './Storage';

export default {
  // component: Storage,
  component: load(() => import(/* webpackChunkName: "Storage" */ './Storage')),
  priority: 500,
  permissions: ['Dashboard'],
  name: 'Storage',
  icon: 'sd',
  drawer: true,
};
